import MerchantsI from '../interfaces/merchants.interface'
import { MerchantsService } from '../services/merchants.service'
import { CreateMerchantPayloadT, GetMerchantParams, GetMerchantsListResponseT } from '../types/merchants.types'

const merchantsService = new MerchantsService()

class MerchantsRealisation implements MerchantsI {
    getMerchantsList(params: GetMerchantParams): Promise<GetMerchantsListResponseT> {
        return merchantsService.getMerchantsList(params)
    }

    createMerchant(payload: CreateMerchantPayloadT): Promise<void> {
        return merchantsService.createMerchant(payload)
    }

    updateMerchant(merchant_id: number, payload: CreateMerchantPayloadT): Promise<void> {
        return merchantsService.updateMerchant(merchant_id, payload)
    }

    deleteMerchant(merchant_id: number): Promise<void> {
        return merchantsService.deleteMerchant(merchant_id)
    }
}

export const merchants = new MerchantsRealisation()
